import React from 'react';
import styled, { css } from 'styled-components/macro';
import {
  themeGetCss,
  themeGetResponsive,
  themeGetAsRem,
  useResponsiveCtx,
} from '@blueprint/ui';

import Box from '../Box';
import Icon from '../Icon';

export const IconBox = styled(Box)`
  ${themeGetCss('nativeDropdown.iconWrapper')}
  box-sizing: content-box;
  display: flex;
  position: absolute;
  right: 0;
  justify-content: center;
  align-items: center;
  -ms-pointer-events: none;
  pointer-events: none;

  &.disabled {
    cursor: not-allowed;
    opacity: 0.3;
  }

  ${({ selectTitle, vMedia }) =>
    !selectTitle &&
    themeGetResponsive({
      vMedia,
      vMediaStyles: css`
        ${themeGetAsRem('nativeDropdown.iconWrapper.small')};
      `,
    })}
`;

const IconWrapper = ({ children, mode, ...rest }) => {
  const { vMedia } = useResponsiveCtx();

  return (
    <IconBox {...rest} vMedia={vMedia}>
      <Icon name="ChevronDown" fill={mode === 'dark' ? '#fff' : '#333'} />
    </IconBox>
  );
};

IconWrapper.displayName = 'IconWrapper';

export default IconWrapper;
